import { render, staticRenderFns } from "./PlanComparison.vue?vue&type=template&id=3e9156f2"
import script from "./PlanComparison.vue?vue&type=script&lang=js"
export * from "./PlanComparison.vue?vue&type=script&lang=js"
import style0 from "./PlanComparison.vue?vue&type=style&index=0&id=3e9156f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports